import { GridColDef } from "@mui/x-data-grid-pro";
import { actionsRender } from "../Datagrid/Renders/ActionsRender";

interface GetResourceColumnsParams {
    setPreviewRow: any
}

export const getResourceColumns = (params: GetResourceColumnsParams) => {
    const { setPreviewRow } = params
    const contractDocumentColumns: GridColDef[] = [
        { field: "name", headerName: "nome", width: 700, filterable: false, editable: false },
        { field: "actions", headerName: "", renderCell: params => actionsRender(params, setPreviewRow), width: 100, filterable: false, sortable: false, resizable: false, hideable: false, disableColumnMenu: true }
    ]

    return contractDocumentColumns
}
